// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const RmaPage = lazy(() => import('./pages/RmaPage'));
const ReturnShippingPage = lazy(() => import('./pages/ReturnShippingPage'));
const ReturnReceivingPage = lazy(() => import('./pages/ReturnReceivingPage'));
const RefundsPage = lazy(() => import('./pages/RefundsPage'));
const WarrantyClaimsPage = lazy(() => import('./pages/WarrantyClaimsPage'));

export const ReverseRoutes: RouteObject = {
  path: 'reverse',
  element: <ModuleGuard moduleId="operations.reverse" />,
  children: [
    { path: 'rma', element: <RmaPage />, handle: { crumb: 'RMA Returns' } },
    { path: 'return-shipping', element: <ReturnShippingPage />, handle: { crumb: 'Return Shipping' } },
    { path: 'return-receiving', element: <ReturnReceivingPage />, handle: { crumb: 'Return Receiving' } },
    { path: 'refunds', element: <RefundsPage />, handle: { crumb: 'Refunds' } },
    { path: 'warranty-claims', element: <WarrantyClaimsPage />, handle: { crumb: 'Warranty Claims' } },
  ],
};
